// ============================================================
// TABS & ACCORDION INIT
// ============================================================

export function initTabs() {
    const tabContainers = document.querySelectorAll('.tabs-container');
    if (!tabContainers.length) return;

    const DESKTOP_BREAKPOINT = 992;

    tabContainers.forEach((container) => {
        const desktopButtons = [...container.querySelectorAll('.tab-btn')];
        const mobileButtons = [...container.querySelectorAll('.accordion-btn')];
        const panels = [...container.querySelectorAll('.tab-panel')];

        if (!desktopButtons.length && !mobileButtons.length && !panels.length) return;

        const isDesktop = () => window.innerWidth >= DESKTOP_BREAKPOINT;

        const getDesktopButton = (id) =>
            container.querySelector(`.tab-btn[data-target="${id}"]`);

        const getMobileButton = (id) =>
            container.querySelector(`.accordion-btn[data-target="${id}"]`);

        const getPanel = (id) =>
            container.querySelector(`.tab-panel[id="${id}"]`);

        const clearState = () => {
            desktopButtons.forEach((btn) => btn.classList.remove('active'));
            mobileButtons.forEach((btn) => btn.classList.remove('active'));
            panels.forEach((panel) => panel.classList.remove('active'));
        };

        const openItem = (id) => {
            const panel = getPanel(id);
            if (!panel) return;

            clearState();

            const desktopButton = getDesktopButton(id);
            const mobileButton = getMobileButton(id);

            desktopButton?.classList.add('active');
            mobileButton?.classList.add('active');
            panel.classList.add('active');
        };

        const closeItem = (id) => {
            const panel = getPanel(id);
            if (!panel) return;

            getDesktopButton(id)?.classList.remove('active');
            getMobileButton(id)?.classList.remove('active');
            panel.classList.remove('active');
        };

        const getActiveId = () => {
            const activeDesktop = container.querySelector('.tab-btn.active');
            if (activeDesktop) return activeDesktop.dataset.target;

            const activeMobile = container.querySelector('.accordion-btn.active');
            if (activeMobile) return activeMobile.dataset.target;

            const activePanel = container.querySelector('.tab-panel.active');
            if (activePanel) return activePanel.id;

            return null;
        };

        const getFirstAvailableId = () => {
            return (
                desktopButtons[0]?.dataset.target ||
                mobileButtons[0]?.dataset.target ||
                panels[0]?.id ||
                null
            );
        };

        const syncToViewport = () => {
            const activeId = getActiveId();

            if (isDesktop()) {
                // Desktop: zawsze ma być jedna aktywna zakładka
                if (activeId) {
                    openItem(activeId);
                } else {
                    const firstId = getFirstAvailableId();
                    if (firstId) openItem(firstId);
                }
            } else {
                // Mobile: może być 0 lub 1 otwarty element
                // jeśli coś jest aktywne, tylko synchronizujemy klasy
                if (activeId) {
                    openItem(activeId);
                }
            }
        };

        // =========================
        // DESKTOP EVENTS
        // =========================
        desktopButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const id = button.dataset.target;
                if (!id) return;

                openItem(id);
            });
        });

        // =========================
        // MOBILE EVENTS
        // =========================
        mobileButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const id = button.dataset.target;
                if (!id) return;

                const isActive = button.classList.contains('active');

                if (isActive && !isDesktop()) {
                    closeItem(id);
                } else {
                    openItem(id);
                }
            });
        });

        // =========================
        // INITIAL SYNC
        // =========================
        syncToViewport();

        // =========================
        // RESIZE SYNC
        // =========================
        let resizeTimer = null;

        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(() => {
                syncToViewport();
            }, 120);
        });
    });
}